// /*
//    Author: Bhavya
//        &&: Piyush Dubey
// */
// import React, { PureComponent } from "react";
// import history from "helper/history";
// import forge from "node-forge";
// import TextInput from "@techsoftware/happay-widgets/TextInput";
// import SearchableSelect from "../../constants/searchableSelect";

// import {
//     CustomPrimaryButton as SaveButton,
//     CustomSecondaryButton as CancelButton,
//     CustomLink as Link,
//     InputElement
// } from "../../customComponents/components";
// import Layout from "./layout";

// import * as LoginAction from "../../actions/loginaction";
// import LoginStore from "../../stores/loginstore";

// import DefaultAutoContainerStore from "../../stores/defaultAutoContainerStore";

// import i18n from "../../i18nNext";

// const txtStyle = {
//     borderRadius: 2,
//     backgroundColor: "#f9fafc",
//     border: "solid 2px #eef2f7",
//     fontSize: 14,
//     height: 36
// };

// export default class PasswordPage extends PureComponent {
//     constructor(props) {
//         super(props);
//         this.state = {
//             user: LoginStore._getField("user"),
//             password: "",
//             toggleBit: "mobile",
//             userId: LoginStore._getField("userId") || "",
//             mandatoryError: false,
//             urlObj: DefaultAutoContainerStore._getUrlObj()
//         };
//         this._handleSubmit = this._handleSubmit.bind(this);
//         this._fieldOnChange = this._fieldOnChange.bind(this);
//     }

//     encryptData(publicKeyIn, pwd) {
//         const publicEncryptionKey = publicKeyIn;
//         const decodePublicKey = forge.util.decode64(publicEncryptionKey);
//         const publicKey = forge.pki.publicKeyFromPem(decodePublicKey);
//         const encrypted = publicKey.encrypt(pwd);
//         const base64Encrypted = forge.util.encode64(encrypted);
//         return base64Encrypted;
//     }

//     _handleSubmit(event) {
//         event.preventDefault();
//         const { password, userId } = this.state;

//         if (!password) {
//             this.setState({
//                 mandatoryError: true
//             });
//             return 0;
//         }
//         let pwd = password.trim();
//         let user = LoginStore._getField("user");

//         if (!pwd) {
//             this.setState({
//                 mandatoryError: true
//             });
//         } else {
//             //Get key from -store
//             let encryptionKey = LoginStore._getEncryptionKey();
//             let encryptedPwd = "";
//             let token_id = "";

//             if (encryptionKey.hasOwnProperty("public_key")) {
//                 encryptedPwd = this.encryptData(encryptionKey.public_key, pwd);
//                 token_id = encryptionKey.token_id;
//             } else {
//                 encryptedPwd = pwd;
//                 token_id = undefined;
//             }

//             //Encrypt password using key & send
//             var data = {
//                 mobile_extension: LoginStore._getField("c_code"),
//                 user: user,
//                 password: encryptedPwd,
//                 token_id: token_id
//             };

//             if (userId) data.user_id = userId;

//             let val = document.getElementById("saveBtn").getAttribute("name");

//             if (val) {
//                 data.hardware_id = val;
//             }
//             LoginAction.loginApi(data);
//         }
//     }

//     _backTopage() {
//         history.goBack();
//     }

//     _fieldOnChange(_event, value) {
//         this.setState({
//             password: value,
//             mandatoryError: false
//         });
//     }

//     handleShowBackButton() {
//         const { urlObj } = this.state;
//         if (urlObj.hasOwnProperty("user") && urlObj.hasOwnProperty("userId")) {
//             return null;
//         }
//         return (
//             <CancelButton
//                 style={{ width: "100%", margin: "0" }}
//                 label={i18n.t("btn.back")}
//                 onClick={this._backTopage.bind(this)}
//             />
//         );
//     }

//     _renderInputField(type) {
//         const { user, password, mandatoryError } = this.state;
//         const cCode = LoginStore._getField("c_code");

//         return (
//             <div className="loginContainer" style={{ margin: "4% auto 1% auto" }}>
//                 <form onSubmit={this._handleSubmit} autoComplete="off">
//                     <div className="mobileLabel">
//                         {type === "mobile" ? i18n.t("lbl.mobile") : i18n.t("lbl.email")}
//                     </div>
//                     <div className="mobileNumberContainer">
//                         {type === "mobile" && (
//                             <div className="countryCode textFieldContainer">
//                                 <SearchableSelect
//                                     type="single-select"
//                                     hideClearAll
//                                     style={{ bottom: "15px", color: "rgb(22, 50, 92)" }}
//                                     hintText="countryCode"
//                                     iconBottom={18}
//                                     data={[]}
//                                     value={cCode}
//                                     dataConfig={{ text: "name", value: "countryCode" }}
//                                     setLabelValue={cCode}
//                                     disabled
//                                 />
//                             </div>
//                         )}
//                         <span
//                             className="mobileNumberField textFieldContainer"
//                             style={
//                                 type === "mobile"
//                                     ? { width: "100%" }
//                                     : { width: "100%", marginLeft: "0" }
//                             }
//                         >
//                             <InputElement
//                                 type="text"
//                                 style={{ ...txtStyle, ...{ width: "100%" } }}
//                                 className="inputElement"
//                                 value={user}
//                                 disabled
//                             />
//                         </span>
//                     </div>
//                     <div className="mobileLabel" style={{ margin: "21px 0 10px 0" }}>
//                         {i18n.t("lbl.password")}
//                     </div>
//                     <TextInput
//                         id="password-field"
//                         name="password-field"
//                         hintText={i18n.t("placeholder.enterPassword")}
//                         value={password}
//                         showEyeIcon
//                         autoFocus
//                         clearMargin
//                         autoComplete="new-password"
//                         errorType={mandatoryError && "error"}
//                         errorText={mandatoryError && i18n.t("err.pleaseEnterThePassword")}
//                         onChange={this._fieldOnChange}
//                     />
//                     <div className="buttonContainer">
//                         <div style={{ textAlign: "left", width: "45%", marginRight: "5%" }}>
//                             {this.handleShowBackButton()}
//                         </div>
//                         <div style={{ textAlign: "right", width: "45%", marginLeft: "5%" }}>
//                             <SaveButton
//                                 id="saveBtn"
//                                 label={i18n.t("btn.signIn")}
//                                 type="submit"
//                                 className="nextButton"
//                                 style={{ width: "100%", margin: "0" }}
//                             />
//                         </div>
//                     </div>
//                 </form>
//             </div>
//         );
//     }

//     _selectTab(type) {
//         this.setState({
//             toggleBit: type,
//             mandatoryError: false
//         });
//     }

//     render() {
//         const { user, toggleBit } = this.state;
//         let fromEmail = false;

//         if (user.indexOf("@") > 0) {
//             fromEmail = true;
//         }

//         return (
//             <div>
//                 <Layout fromEmail={fromEmail} selectedTab={type => this._selectTab(type)} />
//                 {this._renderInputField(toggleBit)}
//                 <div className="linkText">
//                     <Link to="/login/mobileverificationpage" style={{ color: "white" }}>
//                         {i18n.t("logIn.signInWithOTP")}
//                     </Link>
//                     <span className="oval"> . </span>
//                     <Link to="/login/cantsignin" style={{ color: "white" }}>
//                         {i18n.t("logIn.cantSignIn?")}
//                     </Link>
//                 </div>
//                 <div className="selectSignInMsg">{i18n.t("logIn.selectSignInMsg")}</div>
//             </div>
//         );
//     }
// }

//---------------- Start External Library Import --------------------//
import React, { PureComponent } from "react";
import PasswordPage from "@techsoftware/happay-widgets/PasswordPage";
import history from "helper/history";
import forge from "node-forge";
//---------------- End External Library Import --------------------//

//------------------- Start Actions Dependency Import-------------------------------------//
import * as LoginAction from "../../actions/loginaction";
//------------------- End Actions Dependency Import -------------------------------------//

//------------------- Start Stores Dependency Import -------------------------------------//
import LoginStore from "../../stores/loginstore";
//------------------- End Stores Dependency Import -------------------------------------//

//------------------- Start Helpers Dependency Import -------------------------------------//
import i18n from "../../i18nNext";
//------------------- End Helpers Dependency Import -------------------------------------//
import HDFCLogo from "../../../public/assets/images/bank/HDFC_Bank_Logo.svg";
import poweredByHappay from "../../../public/assets/images/poweredByHappayImg.svg";

import Common from "../../constants/common";

export default class passwordPage extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            code: LoginStore._getField("c_code"),
            user: LoginStore._getField("user"),
            activeTab: LoginStore._getField("activeTab"),
            userId: LoginStore._getField("userId") || "",
            emailId: LoginStore._getField("emailId")
        };
    }
    encryptData(publicKeyIn, pwd) {
        const publicEncryptionKey = publicKeyIn;
        const decodePublicKey = forge.util.decode64(publicEncryptionKey);
        const publicKey = forge.pki.publicKeyFromPem(decodePublicKey);
        const encrypted = publicKey.encrypt(pwd);
        const base64Encrypted = forge.util.encode64(encrypted);
        return base64Encrypted;
    }

    onSignIn = value => {
        let { user, code, userId } = this.state;
        let pwd = value.password;
        let encryptionKey = LoginStore._getEncryptionKey();
        let encryptedPwd = "";
        let token_id = "";
        if (encryptionKey.hasOwnProperty("public_key")) {
            encryptedPwd = this.encryptData(encryptionKey.public_key, pwd);
            token_id = encryptionKey.token_id;
        } else {
            encryptedPwd = pwd;
            token_id = undefined;
        }

        //Encrypt password using key & send
        var data = {
            mobile_extension: code,
            user: user,
            password: encryptedPwd,
            token_id: token_id
        };
        const hardwareId = sessionStorage.getItem("hardware_id");
        if (sessionStorage.getItem("gmail-addon-info") && hardwareId) {
            data.hardware_id = hardwareId;
            data["OS"] = "iOS";
        }
        if (userId) data.user_id = userId;
        LoginAction.loginApi(data);
    };

    render() {
        const {
            ProductLogo,
            allCountryCode,
            breakPoints,
            privacyPolicyUrl,
            termOfUseUrl
        } = this.props;
        const { code, user, activeTab, emailId } = this.state;
        return (
            <PasswordPage
                containerClassName={`signin-container ${Common._checkIfHdfcUrl() ? 'hdfcPortal': 'happayPortal'}`}
                logo={Common._checkIfHdfcUrl() ? HDFCLogo : ProductLogo}
                breakPoints={breakPoints}
                onSignIn={this.onSignIn}
                onClickBack={() => {
                    if (emailId) {
                        history.push("/login");
                    } else {
                        history.goBack();
                    }
                }}
                onClickOTP={() => history.push("/login/mobileverificationpage")}
                onClickCantSignin={() => history.push("/login/cantsignin")}
                countryCode={allCountryCode}
                data={{
                    code: code,
                    value: user,
                    activeTab: activeTab
                }}
                privacyPolicyUrl={!Common._checkIfHdfcUrl() && privacyPolicyUrl}
                termOfUseUrl={!Common._checkIfHdfcUrl() && termOfUseUrl}
                privacyPolicyText={!Common._checkIfHdfcUrl() && i18n.t("common.privacyPolicy")}
                termOfUseText={!Common._checkIfHdfcUrl() && i18n.t("common.termsOfUse")}
                signInHeader={i18n.t("logIn.signText")}
                emailIdFloatingLabelText={i18n.t("logIn.emailId")}
                emailIdHintText={i18n.t("placeholder.enterEmailID")}
                codeLabelText={i18n.t("lbl.code")}
                phoneNoFoatingLabelText={i18n.t("tableHeader.phoneNumber")}
                phoneNoHintText={i18n.t("placeholder.enterPhoneNumber")}
                backButtonText={i18n.t("btn.back")}
                signInButtonText={i18n.t("btn.signIn")}
                passwordFoatingLabelText={i18n.t("lbl.password")}
                passwordHintText={i18n.t("placeholder.enterPassword")}
                passwordSubFooterTextOne={i18n.t("logIn.signInWithOTP")}
                passwordSubFooterTextTwo={i18n.t("logIn.ifYouHaveForgotten")}
                passwordSubFooterTextThree={i18n.t("logIn.cantSignIn")}
                passwordValidStr={i18n.t("err.enterValidPassword")}
                dialogBoxTitle={i18n.t("logIn.cantSignIn")}
                dialogBoxContentOne={i18n.t("err.youCanSign")}
                dialogBoxContentTwo={i18n.t("err.ifYouStill")}
                footerText={
                    Common._checkIfHdfcUrl() && (
                        <div className="d-flex alignItemCenter">
                            {i18n.t("lbl.poweredBy")}
                            <img src={poweredByHappay} width="80" className="margin-lr-5" />
                        </div>
                    )
                }
            />
        );
    }
}
